import { useState } from "react";
import { Label } from "components/ui/label";
import { RadioGroup, RadioGroupItem } from "components/ui/radio-group";
import clsx from "clsx";

interface RadioProps {
  items: { id: string; label: string; value: string }[];
  value: string;
  onChange?: (value: string) => void;
  className?: string;
}

export default function RadioGroupWithLabel({ items, value, className, onChange }: RadioProps) {
  const [selectedValue, setSelectedValue] = useState<string>(value);

  const handleChange = (value: string) => {
    setSelectedValue(value);
    if (onChange) onChange(value);
  };

  return (
    <RadioGroup value={value} onValueChange={handleChange} className={clsx(``, className)}>
      {items.map((item) => (
        <button
          key={item.id}
          className={clsx(
            "flex items-center justify-between w-full px-4 py-2 border-2 rounded-lg transition-all duration-200",
            selectedValue === item.value ? "border-yellow-500 bg-yellow-400 " : "border-gray-300 hover:bg-gray-100 dark:hover:text-black"
          )}
          onClick={() => handleChange(item.value)}
        >
          <RadioGroupItem value={item.value} id={item.id} className="hidden" />
          <Label htmlFor={item.id} className="text-sm font-medium">
            {item.label}
          </Label>
        </button>
      ))}
    </RadioGroup>
  );
}
